<template>
    <div>
        <!-- Modal Ver Accession Number -->
        <div class="modal fade" id="modalVerAccessionNumber" tabindex="-1" role="dialog" aria-labelledby="modalTitleVerAccessionNumber" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Accession Number</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <az-input
                            label="Accession Number"
                            :edicao="false"
                            v-model="dados.an">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                        @click="copiar_clipboard(dados.an)">
                                        <i class="fas fa-copy"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <div class="mt-3">
                            <button class="btn btn-outline-dark" type="button" @click="open_url_estudo()">
                                <i class="fas fa-x-ray mr-2"></i> 
                                Abrir Estudo no PACS
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return {
            dados: null,
        };
    },

    components: { 
        AzInput,
    },

    props: ['id_paciente'], 

    methods: {
        abrir(dados) {
            this.dados = dados;
            $('#modalVerAccessionNumber').modal('show');
        },

        copiar_clipboard (text) {
            this.$util.copiar_clipboard(this, text, 'Accession Number copiado com sucesso!');
        },

        open_url_estudo() {
            this.$util.atualizar(this, {
                service: 'pep',
                func: 'dr_tis_url',
                redir_api: true,
                dados: {
                    id_atendimento_procedimento: _.get(this.dados, 'id_atp'),
                    id_paciente: this.id_paciente,
                },
                callback: (res) => {
                    if(res && res.url) {
                        this.$util.pacs_open_window(res.url);
                    }
                }
            });
        },
    },
}
</script>